module.exports = __webpack_public_path__ + "img/react.f5adc940.svg";